import { useCurrentUser } from "../AuthWrapper2/hooks/useCurrentUser.js";
import { useMemo } from "react";
// src/modules/shared/UserAnPCheck.tsx
/**
* Conditional check of a User
*/
function UserAnPCheck({ check, children, childrenOnCheckFail, memoCheck = true }) {
	const user = useCurrentUser();
	return useMemo(() => user.superAdmin || check(user), [user, memoCheck ? false : check]) ? children : childrenOnCheckFail;
}
export { UserAnPCheck };

//# sourceMappingURL=UserAnPCheck.js.map